const UNAVAILABLE_DATES_STORAGE_KEY = 'unavailableDates';
const UNAVAILABLE_DATES_EVENT = 'updatedUnavailableDates';

export function syncUnavailableStartDates(dates: (string | null)[] | undefined | null): void {
  if (!dates?.length || globalThis.window === undefined) return;

  const stored = sessionStorage.getItem(UNAVAILABLE_DATES_STORAGE_KEY);
  const prev = stored ? JSON.parse(stored) : null;

  sessionStorage.setItem(UNAVAILABLE_DATES_STORAGE_KEY, JSON.stringify({ blueprintId: prev?.blueprintId, dates }));
  globalThis.dispatchEvent(new Event(UNAVAILABLE_DATES_EVENT));
}
